(function () {
  'use strict';

  function pawAddToCart(id, quantity, onSuccess, onError) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: parseInt(quantity, 10) || 1 })
    })
      .then(function (res) { return res.json(); })
      .then(onSuccess)
      .catch(onError || function (e) { console.error('ATC error', e); });
  }

  function dispatchCartEvents(item) {
    ['cart:updated', 'cart:add'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { item: item } }));
    });
    if (window.jQuery) {
      jQuery(document).trigger('cart:updated', [{ item: item }]);
      jQuery(document).trigger('cart:refresh');
    }
  }

  // Card-level ATC (single-variant)
  document.addEventListener('submit', function (e) {
    if (!e.target.classList.contains('paw-card-atc-form')) return;
    e.preventDefault();
    e.stopPropagation();

    var form = e.target;
    var btn = form.querySelector('button[type="submit"]');
    var id = form.querySelector('[name="id"]').value;
    var qty = (form.querySelector('[name="quantity"]') || {}).value || 1;

    if (btn) btn.disabled = true;

    pawAddToCart(id, qty, function (data) {
      if (btn) btn.disabled = false;
      dispatchCartEvents(data);
    }, function () {
      if (btn) btn.disabled = false;
    });
  });

  // Quickbuy ATC (multi-variant) — capture phase runs before jQuery's form submit
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('.quickbuy__submit');
    if (!btn || btn.disabled) return;

    var form = btn.closest('form');
    if (!form || !form.classList.contains('ajax-product-form')) return;

    // Prevent default click action (form submission) so jQuery submit handler never fires
    e.preventDefault();
    e.stopImmediatePropagation();

    var selectEl = form.querySelector('[data-product-select]');
    var id = selectEl ? selectEl.value : (form.querySelector('[name="id"]') || {}).value;
    var qty = (form.querySelector('[name="quantity"]') || {}).value || 1;

    if (!id) return;
    btn.disabled = true;

    pawAddToCart(id, qty, function (data) {
      btn.disabled = false;
      if (window.jQuery && jQuery.colorbox) jQuery.colorbox.close();
      dispatchCartEvents(data);
    }, function () {
      btn.disabled = false;
    });
  }, true); // capture phase

})();
